/** Turns a display phone number like "+381 61 292 9053" into a tel: href like "tel:+381612929053". */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
